import { Vector3 } from "three";

export enum CollisionType {
  Obstacle = "Obstacle",
  ForceField = "ForceField",
  Overlap = "Overlap",
}

export enum EntityType {
  UserAvatar = "UserAvatar",
  Flyer = "Flyer",
  MapReaction = "MapReaction",
  Image = "Image",
  Media = "Media",
  Timer = "Timer",
  Gallery = "Gallery",
}

export enum Components {
  text = "Text",
  lookingAt = "LookingAt",
  images = "Images",
  videos = "Videos",
  files = "Files",
  reactions = "Reactions",
  usersTrack = "UsersTrack",
}

export interface Entity {
  id: string;
  type: EntityType;
  ownerId: string;
  components: Components[];
  coord: Vector3;
  componentProperties: Partial<Record<Components, any>>;
  collisionType: CollisionType;
  creationDate: Date;
}
